import L from 'leaflet';
import PropTypes from 'prop-types';

import useLeafletLayer from './useLeafletLayer';

function LeafletZoomControl(props) {
  const { position = 'topleft' } = props;

  useLeafletLayer(() => L.control.zoom({ position }));

  return null;
}

LeafletZoomControl.propTypes = {
  position: PropTypes.oneOf(['topleft', 'topright', 'bottomleft', 'bottomright']),
};

export default LeafletZoomControl;
